import { commonTr } from './common'
import { domainsTr } from './domains'
import { mergeDictionaries, type Dictionary } from './types'

export type { DictValue, Dictionary } from './types'
export { mergeDictionaries } from './types'

const shellNavTr: Dictionary = {
  shell: {
    searchPlaceholder: 'Hızlı ara…',
    notifications: 'Bildirimler',
    pendingCount: '{count} okunmamış bildirim',
    noPending: 'Okunmamış bildirim yok',
    markAllRead: 'Tümünü okundu işaretle',
    emptyNotifications: 'Henüz bildirim yok',
    justNow: 'Az önce',
    minutesAgo: '{count} dk önce',
    hoursAgo: '{count} sa önce',
    daysAgo: '{count} g önce',
    notifCat: {
      orders: 'Siparişler',
      payments: 'Ödemeler',
      tickets: 'Destek',
      messages: 'Mesajlar',
      livechat: 'Canlı destek',
      adverts: 'İlanlar',
      wallet: 'Cüzdan',
    },
    lightTheme: 'Açık tema',
    darkTheme: 'Koyu tema',
    openMenu: 'Menüyü aç',
    closeMenu: 'Menüyü kapat',
    sidebar: 'Kenar çubuğu',
    expandSidebar: 'Kenar çubuğunu genişlet',
    collapseSidebar: 'Kenar çubuğunu daralt',
    collapse: 'Daralt',
    logout: 'Çıkış',
    logoutFull: 'Çıkış yap',
    logoutDone: 'Çıkış yapıldı',
    menuLoading: 'Menü yükleniyor…',
    planModules: 'Plan modülleri',
    footerTagline: 'CodexFix · Modern E-Ticaret Yönetim Paneli',
    footerBuiltWith: 'Bu panel CodexFix altyapısı ile hazırlanmıştır.',
    sidebarFooter: 'CodexFix altyapısı',
    platformBanner:
      'Platform desteği oturumu — müşteri yönetim paneline yönetici olarak girdiniz.',
    closeSession: 'Oturumu kapat',
  },
  nav: {
    section: {
      sales: 'Alış-Satış Yönetimi',
      products: 'Ürün Yönetimi',
      members: 'Üye & Destek Yönetimi',
      content: 'İçerik Yönetimi',
    },
    home: 'Ana Sayfa',
    reports: 'Raporlar',
    salesReports: 'Satış Raporları',
    stockReports: 'Stok Raporları',
    memberReports: 'Üye Raporları',
    analytics: 'Analitik',
    ordersPayments: 'Sipariş & Ödeme Yönetimi',
    orders: 'Sipariş Listesi',
    orderTickets: 'Müşteri Talepleri',
    frauds: 'Şüpheli İşlemler',
    transactions: 'İşlem Listesi',
    paymentNotifications: 'Ödeme Bildirimleri',
    balanceRequests: 'Bakiye Çekimleri',
    invoices: 'Fatura Listesi',
    advertsMgmt: 'İlan Yönetimi',
    adverts: 'İlan Listesi',
    advertDopings: 'İlan Doping',
    sellerRequests: 'Satıcı Hesap Talepleri',
    sellerWarnings: 'Satıcı Uyarıları',
    phoneRequests: 'Telefon Arama İstekleri',
    messageTemplates: 'Mesaj Şablonları',
    profileAddons: 'Profil Eklentileri',
    advertCategories: 'İlan Kategorileri',
    advertComments: 'Satıcı Yorumları',
    advertCommissions: 'Pazaryeri Komisyonları',
    marketplaceHub: 'Pazaryeri Entegrasyonu',
    advertRules: 'İlan Kuralları',
    categoryMgmt: 'Kategori Yönetimi',
    categories: 'Kategori Listesi',
    brands: 'Marka Listesi',
    categoryTypes: 'Kategori Türleri',
    platforms: 'Kategori Platformları',
    productMgmt: 'Ürün Yönetimi',
    products: 'Ürün Listesi',
    productTypes: 'Ürün Türleri',
    stockMgmt: 'Stok Yönetimi',
    stocks: 'Stok Listesi',
    virtualStocks: 'Sanal Stok',
    suppliers: 'Tedarikçi Listesi',
    supplierTransactions: 'Tedarikçi Hareketleri',
    marketplaceMgmt: 'Mağaza Yönetimi',
    marketplaces: 'Mağaza Listesi',
    marketplacePrices: 'Mağaza Ürün Fiyatları',
    marketplaceApplications: 'Mağaza Başvuruları',
    customerMgmt: 'Müşteri Yönetimi',
    customers: 'Müşteri Listesi',
    customerTypes: 'Müşteri Türleri',
    customerRestrictions: 'Müşteri Kısıtlamaları',
    customerApi: 'Müşteri API',
    purchases: 'Satın Alım Listesi',
    apiOrders: 'API Siparişleri',
    ticketTypes: 'Talep Tipleri',
    purchaseReports: 'Alış Raporları',
    supplierBanks: 'Tedarikçi Banka Hesapları',
    marketplaceCategories: 'Mağaza Kategorileri',
    customerTransactions: 'Müşteri Hareketleri',
    customerNotifications: 'Müşteri Bildirimleri',
    staffMgmt: 'Personel Yönetimi',
    staff: 'Personel Listesi',
    permissions: 'İzin Yönetimi',
    supportMgmt: 'Destek Yönetimi',
    inbox: 'Gelen Kutusu',
    whatsapp: 'WhatsApp Yazışma',
    livechat: 'Canlı Destek',
    tickets: 'Destek Masası',
    couponMgmt: 'Kupon Yönetimi',
    coupons: 'Kupon Listesi',
    wheel: 'Şans Çarkı',
    wheelMgmt: 'Çark Yönetimi',
    points: 'Puan Hareketleri',
    themeMgmt: 'Tema Yönetimi',
    themes: 'Tasarım Ayarları',
    pageTemplates: 'Sayfa Yönetimi',
    siteContents: 'Site İçerikleri',
    widgets: 'Anasayfa Widgetleri',
    headerMenu: 'Header Menü',
    footerMenu: 'Footer Menü',
    legalPages: 'Yasal Sayfalar',
    faq: 'SSS / FAQ',
    customContents: 'Özel İçerikler',
    kvkk: 'KVKK / Çerez',
    seo: 'SEO & Analitik',
    blogNews: 'Blog & Haber',
    blogs: 'Blog Listesi',
    blogCategories: 'Blog Kategorileri',
    siteSettings: 'Site Ayarları',
    planModules: 'Plan & Modüller',
    generalSettings: 'Genel Ayarlar',
    security: 'Güvenlik & Erişim',
    messaging: 'Mesajlaşma',
    emailTemplates: 'E-posta Şablonları',
    panelSettings: 'Panel Ayarları',
    integrations: 'Entegrasyonlar',
    payments: 'Ödeme İşlemcileri',
    marketplaceIntegrations: 'Pazaryeri Entegrasyonları',
    cargo: 'Kargo Firmaları',
    shippingMethods: 'Kargo Yöntemleri',
    eInvoice: 'e-Fatura',
    sms: 'SMS Sağlayıcı',
    partnerApi: 'Partner API',
    topup: 'TopUp Botlar',
    aiSettings: 'AI Ayarları',
  },
  crumbs: {
    dashboard: 'Dashboard',
    products: 'Ürünler',
    orders: 'Siparişler',
    categories: 'Kategoriler',
    'category-types': 'Kategori türleri',
    brands: 'Markalar',
    'product-types': 'Ürün türleri',
    platforms: 'Kategori platformları',
    customers: 'Müşteriler',
    coupons: 'Kuponlar',
    settings: 'Genel ayarlar',
    'plan-modules': 'Plan & Modüller',
    new: 'Yeni',
    login: 'Giriş',
    detail: 'Detay',
    stocks: 'Stoklar',
    'virtual-stocks': 'Sanal stok',
    marketplaces: 'Mağazalar',
    'marketplace-prices': 'Mağaza fiyatları',
    blogs: 'Bloglar',
    themes: 'Temalar',
    widgets: 'Widgetler',
    'site-contents': 'Site içerikleri',
    'panel-settings': 'Panel ayarları',
    security: 'Güvenlik',
    livechat: 'Canlı destek',
    tickets: 'Destek',
    inbox: 'Gelen kutusu',
    reports: 'Raporlar',
    analytics: 'Analitik',
    adverts: 'İlanlar',
    staff: 'Personel',
    permissions: 'İzinler',
    expenses: 'Giderler',
    wheel: 'Şans çarkı',
    points: 'Puanlar',
    topup: 'TopUp',
    sms: 'SMS',
    cargo: 'Kargo',
    payments: 'Ödemeler',
    invoices: 'Faturalar',
    fraud: 'Fraud',
    suppliers: 'Tedarikçiler',
  },
  command: {
    title: 'Komut paleti',
    placeholder: 'Sayfa, kategori, ürün, sipariş veya müşteri ara…',
    empty: 'Sonuç bulunamadı.',
    hint: '↑↓ gezin · Enter seç ·',
    quickJump: 'Hızlı geçiş',
    menu: 'Menü',
    results: 'Sonuçlar',
    searching: 'Aranıyor…',
    overview: 'Özet',
    blog: 'Blog',
  },
}

export const tr: Dictionary = mergeDictionaries(commonTr, shellNavTr, domainsTr)
